export enum LoginArt {
    login = 'login',
    signUp = 'sign-up'
}
